import {
  AttacksSummaryLayout,
  AttacksSummaryPeriod
} from '@server/graphql/typeDefs/types'
import moment from 'moment'

export const DEFAULT_DATE_START = moment.utc().toISOString()
export const DEFAULT_SUMMARY_LAYOUT = AttacksSummaryLayout.Alphabetical
export const DEFAULT_SUMMARY_PERIOD = AttacksSummaryPeriod.Day
